module.exports = __webpack_public_path__ + "static/media/i4.1e127d69.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/i4.svg
// module id = 201
// module chunks = 8